export const TEXT_TYPES = {
    FILE_NAME: "File Name",
    UPLOAD_PROGRESS: "Upload Progress",
    SUCCESS_MSG : "Success.",
    FAILED_MSG : "Failed.",
    UPLOAD_COVER_IMAGE: "Upload Cover Image",
    SELECT_COVER_UPLOAD_NOTE: "Hint: Click on the Select button and look for some .ZIP files to upload. These can contain .JPG, .PDF or .TIFF",
    UPLOAD_COVER_IMAGE_CONFIRMATION: "Upload Confirmation",
    UPLOAD_COVER_IMAGE_CONFIRMATION_MSG: "Are you sure you want to Upload this file ?",
    UPLOAD_COVER_IMAGE_SUCCESS_MSG: "Your files are being uploaded. Batch id : ",
   
    UPLOAD_COVER_IMAGE_METADATA: "Upload Cover Image Metadata",
    COVER_METADATA_TYPE: "COVER",
    FILE_ALREADY_EXISTS_MSG: "File Already Exists",
    FILE_ALREADY_EXISTS_REPLACE_MSG: "Would you like to replace the file?",
    UPLOAD_SUMMARY: "Upload Summary",
    SELECT_COVER_METADATA_UPLOAD_NOTE: "Hint: Click on the Select button and look for some .XLS/.XLSX files to upload.",
    UPLOAD_COVER_METADATA_CONFIRMATION: "Upload Confirmation",
    UPLOAD_COVER_METADATA_ALREADY_EXIST: "File Already Exists",
    UPLOAD_COVER_METADATA_ALREADY_EXIST_MSG: "The resource titled $file already exists on the destination repository. Do you wish to replace the existing file?",
    UPLOAD_COVER_METADATA_CONFIRMATION_MSG: "Are you sure you want to Upload this file - $file ?",
    UPLOAD_COVER_METADATA_SUCCESS_MSG: "Your file - $file is being uploaded. Batch id : ",
   
    UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS: "Upload Cover Image Template Details",
    SELECT_COVER_IMAGE_TEMPLATE_DETAILS_UPLOAD_NOTE: "Hint: Click on the Select button and look for some .XLS/.XLSX files to upload.",
    UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_CONFIRMATION: "Upload Confirmation",
    UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_CONFIRMATION_MSG: "Are you sure you want to Upload this file - $file ?",
    UPLOAD_COVER_IMAGE_TEMPLATE_DETAILS_SUCCESS_MSG: "Your file - $file is being uploaded. Batch id : ",
    COVER_TEMPLATE_METADATA: "COVER_TEMPLATE",

    COVER_TEMPLATE_UPLOAD_STATUS: "Cover Template Details Upload Status",
    COVER_METADATA_UPLOAD_STATUS: "Cover Image Metadata Upload Status",
    COVER_UPLOAD_STATUS: "Cover Image Upload Status",

    VIEW_STATUS_MSG: " View status here."
};
export const PERMISSIONS = {
    hide_only_actions_tab :'hide_only_actions_tab',
    view_only_product_delivery_type :'view_only_product_delivery_type',
    hide_only_sidebar : 'hide_only_sidebar',
    hide_only_pending_collections_button :'hide_only_pending_collections_button',
    hide_only_loaderIndicator : 'hide_only_loaderIndicator',
    hide_only_sidebar_menuItems:'hide_only_sidebar_menuItems',
    BIEW_only_salesrep_search_PAGE:'view_only_salesrep_search_page',
};
export const SALESREP={
    SEARCH_ANY_COLLECTION:"Search any collection",
    CLICK:"Click ",
    SALESREP_SEARCH:"Sales Rep Search ",
    FIND_COLLECTION:"to find a Collection.",

    VIEW_ONLY_MODE_FOR_ANY_COLLECTION:"View only mode for a collection",
    TO_VIEW_A_COLLECTION:"To view a Collection:",
    SEARCH_FOR_IT_A_LIST_OF_COLLECTIONS_APPEAR:"1. Search for it. A list of Collections appear.",
    CLICK_THE_TITLE_COLLECTION_YOU_WANT_TO_EXAMIN:"2. Click the title of the Collection you want to examine. The details of the Collection appear on the screen. ",

    SEE_COLLECTION_INSTITUTION:"See collections by institution ",
    CLICK_SALESREP_SEARCH:"1.Click ",
    ENTER_NAME_INSTITUTION_SEE:"2.Enter the name of the institution you want to see. ",
    CLICKS:"3.Click ",
    CLICK_SEARCH:"Search",

    SEE_COLLECTION_CREATED:"See Collections created by you ",
    COLLECTION_LIST:" Collection Lists ",
    COLLECTION_CREATED:"to find the Collections you created.",

    CHANGE_COURSE_DATE:"Change course end date",
    CHANGE_COURSE_ASSOCIATED_DIGITAL_COLLECTION:"To change the end of a course associated with a digital Collection: ",
    SEARCH_LIST_COLLECTION_APPEAR:"1.Search for it. A list of Collection appear.",
    CLICK_TITLE_COLLECTION_MODIFY:"2.Click the title of the Collection you want to modify.",
    SELECT:"3.Select ",
    COURSE:"Course Details ",
    COURSE_DETAILS:"to see the start and end date of the course.",
    SELECT_THE:"4.Select the ",
    EDIT_COURSE_END_DATE:"Edit course end date ",
    FIELD_ENTER:"field and enter the new date you want to use. ",

    ADD_INSTRUCTOR:"Add instructors ",
    ADD_INSTRUCTORS_COURSE_DIGITAL_COLLECTION:"To add instructors to a course associated with a digital Collection: ",
    SEARCH_LIST_COLLECTION:"1.Search for it. A list of Collection appear.",
    CLICK_COLLECTION_MODIFY:" 2.Click the title of the Collection you want to modify. ",
    SELECT_COURSE_DETAIL:`3.Select Course Details.`,
    INSTRUCTOR_NAME:" Instructor name ",
    ENTER_NAME_INSTRUCTOR:"field and enter the names of the instructors you want to add.",
    view_only_salesrep_search_page:'view_only_salesrep_search_page',
    view_only_sidebar_expanded:'view_only_sidebar_expanded',
    view_only_instructor_navigation_button : 'view_only_instructor_navigation_button'
};



// WEBPACK FOOTER //
// ./src/constants/APP_CONSTANTS.js